export default __webpack_public_path__ + "static/ticket-de124a3f0a403142a918dea421c8315f.png";